import { DependencyList, useEffect, useMemo, useRef, useState } from 'react'
import useStableCallback from './useStableCallback'

export const useMidnightIntervalMemo = <T>(fn: () => T, deps: DependencyList): T => {
  const [trigger, setTrigger] = useState(1)
  const timeoutRef = useRef<NodeJS.Timeout>()
  const stableFn = useStableCallback(fn)
  const stableScheduleTrigger = useStableCallback(() => {
    function scheduleTrigger() {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      const now = new Date()
      const nextMidnight = new Date(now)
      nextMidnight.setHours(24, 0, 0, 0) // move to today's midnight + 1 day
      const msUntilMidnight = nextMidnight.getTime() - now.getTime()
      timeoutRef.current = setTimeout(() => {
        setTrigger(trigger => trigger + 1)
        scheduleTrigger()
      }, msUntilMidnight)
    }
    scheduleTrigger()
  })
  useEffect(() => {
    stableScheduleTrigger()
    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [stableScheduleTrigger])
  const result = useMemo(() => {
    return stableFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, trigger, stableFn])
  return result
}
